import Fuse from 'fuse.js';

export function searchVideosOnly(channels, query) {
    const allVideos = [];

    channels.forEach(channel => {
        (channel.playlists || []).forEach(playlist => {
            (playlist.content || []).forEach(video => {
                allVideos.push({ ...video, channel }); // include channel info if needed
            });
        });
    });

    const fuse = new Fuse(allVideos, {
        keys: ['title', 'description'],
        threshold: 0.4,
    });

    return fuse.search(query).map(result => result.item);
}
